import Login from './components/Login.vue';
import Layout from './components/Layout.vue';

export const routes = [
	{path: `${window.location.pathname}`, component: Login, name: 'login'},
	{path: `${window.location.pathname}ams`, component: Layout, name: 'ams'}
];